import {
  useSubscriptionStore,
  subscriptionStoreSelector,
} from '@repo/subscription/client';
import { create } from 'zustand';

import { planSelectionStateCreator } from './state';

export * from './selector';

export const usePlanSelectionStore = create(planSelectionStateCreator);

useSubscriptionStore.subscribe(
  subscriptionStoreSelector.subscription,
  (subscription) => {
    if (!subscription) {
      usePlanSelectionStore.getState().actions.reset();
    }
  }
);
